<template>
    <div class="form">
        <!--步骤条-->
        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>
        <!--第一页（申报信息）-->
        <div v-show="active === 0">
            <!--公安机关选择-->
            <select-police :matterInfo="matterInfo" :declareInfo="declareInfo.taskApply" ref="selectpolice"
                           :informationShowData="informationShowData"></select-police>
            <!--基本信息-->
            <basic-information :userInfo="userInfo" :declareInfo="declareInfo.taskApply" ref="basicinformation"
                               :informationShowData="informationShowData"></basic-information>
            <!--定制化表单-->
            <p class="title">基本信息</p>
            <van-cell-group>
                <van-field required readonly clickable label="证件种类" :value="idTypeName" placeholder="请选择"
                           @click="showPickerIdType = true" input-align="right" is-link/>
                <van-popup v-model="showPickerIdType" position="bottom">
                    <van-picker show-toolbar :columns="idTypeList" value-key="name" @cancel="showPickerIdType = false" @confirm="onConfirmIdType"/>
                </van-popup>
                <van-field v-model="declareInfo.bodyBak.cardNum" required clearable label="证件号码" placeholder="请输入证件号码"
                           input-align="right"/>
                <van-field required readonly clickable label="国家/地区" :value="countryAreaName" placeholder="请选择"
                           @click="showPickerCountryArea = true" input-align="right" is-link/>
                <van-popup v-model="showPickerCountryArea" position="bottom">
                    <van-picker show-toolbar :columns="countryAreaList" value-key="name" @cancel="showPickerCountryArea = false" @confirm="onConfirmCountryArea"/>
                </van-popup>
                <van-field required readonly clickable label="地域类别" :value="regionTypeName" placeholder="请选择"
                           @click="showPickerRegionType = true" input-align="right" is-link/>
                <van-popup v-model="showPickerRegionType" position="bottom">
                    <van-picker show-toolbar :columns="regionTypeList" value-key="name" @cancel="showPickerRegionType = false" @confirm="onConfirmRegionType"/>
                </van-popup>
                <van-field v-model="declareInfo.bodyBak.englishSurname" required clearable label="英文姓"
                           placeholder="请输入英文姓" input-align="right"/>
                <van-field v-model="declareInfo.bodyBak.englishName" clearable label="英文名" placeholder="请输入英文名"
                           input-align="right"/>
                <van-field v-model="declareInfo.bodyBak.chineseName" clearable label="中文姓名" placeholder="请输入中文姓名"
                           input-align="right"/>
                <van-field required readonly clickable label="性别" :value="sexName" placeholder="请选择"
                           @click="showPickerSex = true" input-align="right" is-link/>
                <van-popup v-model="showPickerSex" position="bottom">
                    <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerSex = false" @confirm="onConfirmSex"/>
                </van-popup>
                <van-field clickable readonly label="证件有效期至" :value="period" placeholder="请选择"
                           @click="showPickerIdDate = true" input-align="right" is-link/>
                <van-popup v-model="showPickerIdDate" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="date" :min-date="minDate"
                                         @cancel="showPickerIdDate = false" @confirm="onConfirmPeriodDate"/>
                </van-popup>
                <van-field required readonly clickable label="出生日期" :value="birthday" placeholder="请选择"
                           @click="showPickerBirthDate = true" input-align="right" is-link/>
                <van-popup v-model="showPickerBirthDate" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="date" :max-date="minDate"
                                         @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>
                </van-popup>
                <van-field v-model="declareInfo.bodyBak.myTel" clearable label="本人联系电话" placeholder="请输入本人联系电话"
                           input-align="right"/>
                <van-field v-model="declareInfo.bodyBak.idCard" clearable label="身份证号" placeholder="请输入身份证号"
                           input-align="right"/>
            </van-cell-group>
            <p class="title">入境及签证证件信息</p>
            <van-cell-group>
                <van-field required readonly clickable label="签证证件种类" :value="visaIdTypeName" placeholder="请选择"
                           @click="showPickerVisaIdType = true" input-align="right" is-link/>
                <van-popup v-model="showPickerVisaIdType" position="bottom">
                    <van-picker show-toolbar :columns="visaIdTypeList" value-key="name" @cancel="showPickerVisaIdType = false" @confirm="onConfirmVisaIdType"/>
                </van-popup>
                <van-field required v-model="declareInfo.bodyBak.visaIdCard" clearable label="签证证件号码"
                           placeholder="请输入签证证件号码" input-align="right"/>
                <van-field required readonly clickable label="居住地派出所" :value="residentialPoliceStation" placeholder="请选择"
                           @click="showPickerPoliceStation = true" input-align="right" is-link/>
                <van-popup v-model="showPickerPoliceStation" position="bottom">
                    <van-picker show-toolbar :columns="residentialPoliceStationList" value-key="name" @cancel="showPickerPoliceStation = false" @confirm="onConfirmResidentialPoliceStation"/>
                </van-popup>
            </van-cell-group>
            <div class="btn-submit-div btn-submit-back">
                <van-button type="info" size="large" @click="next(1)">下一步</van-button>
            </div>
        </div>
        <!--第二页（附件上传）-->
<!--        <div v-show="active === 1" v-if="isUpload">-->
<!--            <p class="title">附件上传</p>-->
<!--            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">-->
<!--                <upload-image :title="item.itemName" :required="item.requred === 'Y'" :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"-->
<!--                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData" @setImageInfo="getImageInfo"-->
<!--                              @setIsImages="getIsImages"></upload-image>-->
<!--            </van-cell-group>-->
<!--            <div class="btn-submit-div-double">-->
<!--                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>-->
<!--                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>-->
<!--            </div>-->
<!--        </div>-->
        <!--第四页（提交确认）-->
        <div v-show="active === 1">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData" @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo' @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 出入境定制化事项
     * Author: liuxw
     * Date: 2019-09-14
     * Time: 11:51
     */

    import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker } from 'vant'
    import { matterApiMap } from '@/api/matter'
    import Steps from "@/components/declare/Steps"
    import SelectPolice from "@/components/declare/SelectPolice"
    import BasicInformation from "@/components/declare/BasicInformation"
    import UploadImage from "@/components/upload-image/UploadImage"
    import Mailing from "@/components/declare/Mailing"
    import InformationShow from "@/components/declare/InformationShow"
    import { taskApiMap } from "@/api/task"
    import {idCardType, crjCountyArea, areaType, sex, crjCardType, residentialPoliceStation} from "@/api/crj-dict/index"
    import {dateToString} from '@/utils/time'


    export default {
        name: "StandardMatter",
        components: {
            InformationShow,
            Mailing,
            UploadImage,
            Steps,
            SelectPolice,
            BasicInformation,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息

                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了

                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏

                informationShowData: { // 展示信息
                    deptName: '', // 公安机关中文名（展示信息）
                    name: '', // 姓名（展示信息）
                    idNum: '', // 身份证（展示信息）
                    address: '', // 地址（展示信息）
                    phone: '', // 联系方式（展示信息）
                    isUpload: false, // 是否有附件上传状态（展示信息）
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: '', // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '' // 工本费（展示信息）
                },
                declareInfo: {
                    taskApply: {
                        // 标准事项内容
                        matNum: '',
                        deptId: '',
                        linkAddress: '',
                        linkPhone: '',
                        netProjectType: "WEI",
                        tskSource: "SYS",
                        isMailMertal: '0',
                        wfId: '',
                        manifests: [],
                        addressGuidQj: '',
                        addressGuidSh: '',
                        qjMoney: '',
                        shMoney: '',
                        gbMoney: '',
                        emsConfig: ''
                    },
                    // 定制化表单内容
                    bodyBak: {
                        cardType: '',
                        cardNum: '',
                        countryArea: '',
                        regionType: '',
                        englishSurname: '',
                        englishName: '',
                        chineseName: '',
                        sex: '',
                        period: '',
                        birthday: '',
                        myTel: '',
                        idCard: '',
                        visaIdType: '',
                        visaIdCard: '',
                        policeStation: ''
                    }
                },
                idTypeName: '', //证件类型名称
                countryAreaName: '', //国家地区名称
                regionTypeName: '', //地域类别名称
                sexName: '', // 性别名称
                visaIdTypeName: '', // 签证证件种类名称
                period: '', // 证件有效期
                birthday: '', // 出生日期
                residentialPoliceStation: '', // 区域地派出所名称
                idTypeList: idCardType, //证件种类集合
                countryAreaList: crjCountyArea, //国家地区集合
                regionTypeList: areaType, //地域类别集合
                sexList: sex, //性别集合
                visaIdTypeList: crjCardType, //签证证件种类集合
                residentialPoliceStationList: residentialPoliceStation, //居住地派出所集合
                showPickerIdType: false, // 是否显示证件种类选择框
                showPickerCountryArea: false, // 是否显示国家/地区选择框
                showPickerRegionType: false, // 是否显示地域类别选择框
                showPickerSex: false, // 是否显示性别选择框
                showPickerVisaIdType: false, // 是否显示签证证件种类选择框
                showPickerIdDate: false, // 是否显示证件有效期至选择框
                showPickerBirthDate: false, // 是否显示出生日期选择框
                showPickerPoliceStation: false, // 是否显示居住地派出所选择框
                currentDate: new Date(),
                minDate: new Date()
            }
        },
        mounted() {
            this.getMatterInfo()
            this.getUserInfo()
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            /**
             * 获取事项信息
             */
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    this.declareInfo.taskApply.matNum = res.data.data.matNum
                    if (this.matterInfo.manifests.length) {
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                    this.declareInfo.taskApply.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.declareInfo.taskApply.isMailMertal = '101'
                    }
                    this.declareInfo.taskApply.wfId = this.matterInfo.wfId
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 获取个人信息
             */
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = ''
                    }
                    this.userInfo.fullAddress = fullAddress
                }
            },

            /**
             * 下一页
             * @param index 传入每一页下标
             */
            next(index) {
                Toast.clear()
                if (index === 1) { // 申报信息页面验证
                    this.$refs.selectpolice.setDeptId() // 部门赋值
                    this.$refs.basicinformation.setBasicInfo() // 申请人信息赋值
                    if (!this.declareInfo.taskApply.deptId) {
                        Toast('请选择公安机关')
                        return
                    }
                    if(!this.checkOneStep()) {
                        return
                    }
                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'
                        this.active = 1
                    } else if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 1
                    } else {
                        this.active = 1
                    }
                }
            },

            /**
             * 上一页
             * @param index 传入每一页下标
             */
            up(index) {
                console.log(index)
                 if (index === 1) {
                     this.active = 0
                }
            },

            /**
             * 接收事项信息展示组件传来的值，改变active参数
             * @param value 传来的下标，改变active参数
             */
            getActive(value) {
                this.active = value
            },
            /**
             * 校验第一步信息
             */
            checkOneStep() {
                if(!this.declareInfo.taskApply.linkPhone) {
                    Toast('请输入联系电话')
                    return false;
                }
                if(!this.declareInfo.taskApply.linkAddress) {
                    Toast('请输入联系地址')
                    return false;
                }
                if(!this.declareInfo.bodyBak.cardType) {
                    Toast('请选择证件种类')
                    return false;
                }
                if(!this.declareInfo.bodyBak.countryArea) {
                    Toast('请选择国家地区')
                    return false;
                }
                if(!this.declareInfo.bodyBak.cardNum) {
                    Toast('请选择地域类别')
                    return false;
                }
                if(!this.declareInfo.bodyBak.englishSurname) {
                    Toast('请输入英文姓')
                    return false;
                }
                if(!this.declareInfo.bodyBak.sex) {
                    Toast('请选择性别')
                    return false;
                }
                if(!this.declareInfo.bodyBak.birthday) {
                    Toast('请选择出生日期')
                    return false;
                }
                if(!this.declareInfo.bodyBak.visaIdType) {
                    Toast('请选择签证证件种类')
                    return false;
                }
                if(!this.declareInfo.bodyBak.visaIdCard) {
                    Toast('请输入签证证件号码')
                    return false;
                }
                if(!this.declareInfo.bodyBak.policeStation) {
                    Toast('请选择居住地派出所')
                    return false;
                }
                return true;
            },
            /**
             * 选择居住地派出所
             */
            onConfirmResidentialPoliceStation(value) {
                console.log(value)
                this.residentialPoliceStation = value.name
                this.declareInfo.bodyBak.policeStation = value.name
                this.showPickerPoliceStation = false
            },
            /**
             * 选择证件有效日期
             */
            onConfirmPeriodDate(value) {
                console.log(value)
                this.period = dateToString(value, "yyyy-MM-dd")
                this.declareInfo.bodyBak.period = this.period
                this.showPickerIdDate = false
            },
            /**
             * 选择出生日期
             */
            onConfirmBirthdayDate(value) {
                console.log(value)
                this.birthday = dateToString(value, "yyyy-MM-dd")
                this.declareInfo.bodyBak.birthday = this.birthday
                this.showPickerBirthDate = false
            },
            /**
             * 选择证件种类
             */
            onConfirmIdType(value) {
                console.log(value)
                this.idTypeName = value.name
                this.declareInfo.bodyBak.cardType = value.name
                this.showPickerIdType = false
            },
            /**
             * 选择国家/地区
             */
            onConfirmCountryArea(value) {
                console.log(value)
                this.countryAreaName = value.name
                this.declareInfo.bodyBak.countryArea = value.name
                this.showPickerCountryArea = false
            },
            /**
             * 选择地域类别
             */
            onConfirmRegionType(value) {
                console.log(value)
                this.regionTypeName = value.name
                this.declareInfo.bodyBak.regionType = value.name
                this.showPickerRegionType = false
            },
            /**
             * 选择性别
             */
            onConfirmSex(value) {
                console.log(value)
                this.sexName = value.name
                this.declareInfo.bodyBak.sex = value.name
                this.showPickerSex = false
            },
            /**
             * 选择签证证件类别
             */
            onConfirmVisaIdType(value) {
                console.log(value)
                this.visaIdTypeName = value.name
                this.declareInfo.bodyBak.visaIdType = value.name
                this.showPickerVisaIdType = false
            },
            // 格式化提交数据
            formatterSubmit() {
                const bodyBak = Object.assign({}, this.declareInfo.bodyBak)
                const body = {
                    cardType: {
                        text: '证件种类',
                        val: bodyBak.cardType
                    },
                    cardNum: {
                        text: '证件号码',
                        val: bodyBak.cardNum
                    },
                    countryArea: {
                        text: '地区',
                        val: bodyBak.countryArea
                    },
                    regionType: {
                        text: '地域类别',
                        val: bodyBak.regionType
                    },
                    englishSurname: {
                        text: '英文姓',
                        val: bodyBak.englishSurname
                    },
                    englishName: {
                        text: '英文名',
                        val: bodyBak.englishName
                    },
                    chineseName: {
                        text: '中文名',
                        val: bodyBak.chineseName
                    },
                    sex: {
                        text: '性别',
                        val: bodyBak.sex
                    },
                    period: {
                        text: '证件有效期',
                        val: bodyBak.period
                    },
                    birthday: {
                        text: '出生日期',
                        val: bodyBak.birthday
                    },
                    myTel: {
                        text: '本人联系电话',
                        val: bodyBak.myTel
                    },
                    idCard: {
                        text: '身份证号',
                        val: bodyBak.idCard
                    },
                    visaIdType: {
                        text: '签证种类',
                        val: bodyBak.visaIdType
                    },
                    visaIdCard: {
                        text: '签证号码',
                        val: bodyBak.visaIdCard
                    },
                    residentialPoliceStation: {
                        text: '居住地派出所',
                        val: bodyBak.policeStation
                    }
                }
                this.declareInfo.body = body
            },
            /**
             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并
             * @return {Promise<void>}
             */
            async submit() {
                this.formatterSubmit()
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                console.log(this.declareInfo)
                try {
                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.crjTsks, this.declareInfo)
                    if (res.data.succ) {
                        Toast.clear()
                        Dialog.alert({
                            title: '申报成功',
                            message: `您的办件编号为:${res.data.data}`
                        }).then(() => {
                            this.$router.push('/myHandlingList')
                        })
                    } else {
                        Toast.fail('申报失败')
                    }
                } catch (error) {
                    console.log(error)
                    Toast.clear()
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
